export default [
  {
    type: 'NOT_ENOUGH_CUSTOMERS',
    title: 'Not enough customers where I live'
  },
  {
    type: 'TECHNICAL_PROBLEMS',
    title: 'Technical problems with the app'
  },
  {
    type: 'BAD_EXPIRIENCE',
    title: 'Bad customer experience'
  },
  {
    type: 'MOVING',
    title: 'Moving to a different city'
  },
  {
    type: 'OTHER',
    title: 'Other'
  }
]
